import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const SidebarContext = createContext({});
const useSidebar = () => useContext(SidebarContext);

const SidebarProvider = ({ children }) => {
  const [openCollapsible, setOpenCollapsible] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const values = {
    openCollapsible: openCollapsible,
    setOpenCollapsible: (data) => setOpenCollapsible(data),
    activeTab: activeTab,
    setActiveTab: (data) => setActiveTab(data),
  };
  return (
    <SidebarContext.Provider value={values}>{children}</SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.element,
};

export { SidebarProvider, useSidebar };
